import { render, staticRenderFns } from "./RealtimeUsersLoading.vue?vue&type=template&id=d4c2c960"
import script from "./RealtimeUsersLoading.vue?vue&type=script&lang=ts"
export * from "./RealtimeUsersLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports